var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 3V4.5L8 2.5L6 0.5V2C3.79 2 2 3.79 2 6C2 6.785 2.23 7.515 2.62 8.13L3.35 7.4C3.125 6.985 3 6.505 3 6C3 4.345 4.345 3 6 3ZM9.38 3.87L8.65 4.6C8.87 5.02 9 5.495 9 6C9 7.655 7.655 9 6 9V7.5L4 9.5L6 11.5V10C8.21 10 10 8.21 10 6C10 5.215 9.77 4.485 9.38 3.87Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.0d4a8fc7fb1537470d64d6f3241944a3.svg";
export { ForwardRef as ReactComponent };